import React, { useCallback } from 'react';
import { format, addMonths, subMonths } from 'date-fns';
import { Container, PrevButton, Month, NextButton } from './styled';
import { useDateSelection } from '../..';
import { NextAngle } from '../../../../../icons/NextAngle';

export const MonthSelector = ({ t }: MonthSelectorProps) => {
  const { activeDate, setActiveDate } = useDateSelection();

  const nextMonth = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setActiveDate(addMonths(activeDate, 1));
    },
    [setActiveDate, activeDate],
  );

  const prevMonth = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setActiveDate(subMonths(activeDate, 1));
    },
    [setActiveDate, activeDate],
  );

  return (
    <Container>
      <PrevButton onClick={prevMonth} type="button">
        <NextAngle />
      </PrevButton>
      <Month>{`${t(format(activeDate, 'LLLL'))} ${format(
        activeDate,
        'yyyy',
      )}`}</Month>
      <NextButton onClick={nextMonth} type="button">
        <NextAngle />
      </NextButton>
    </Container>
  );
};

export interface MonthSelectorProps {
  t: (key: string) => string;
}
